import { render, staticRenderFns } from "./IsConvenient.vue?vue&type=template&id=590b1c0b&scoped=true"
import script from "./IsConvenient.vue?vue&type=script&lang=js"
export * from "./IsConvenient.vue?vue&type=script&lang=js"
import style0 from "./IsConvenient.vue?vue&type=style&index=0&id=590b1c0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590b1c0b",
  null
  
)

export default component.exports